export * from 'vue-property-decorator'
export { BaseComponent, BasePage, Component } from 'kuaidong-component'
import { Component, BasePage } from 'kuaidong-component'

/**
 * 老师的基础页面，增加老师相关的通用业务
 */
@Component
export class BaseTeacherPage extends BasePage {
  // 是否体智云大学版的学校老师
  get isCollegeTeacher(): boolean {
    return this.$p.Teacher.isCollegeTeacher
  }
}
